import type {
  CreateMarkupSceneRequest,
  MarkupSceneDetail,
  MarkupSceneSummary,
  UpdateMarkupSceneRequest,
} from '@brandschutz/shared';
import { api } from '@/lib/api';

export async function listScenes(projectId: number): Promise<MarkupSceneSummary[]> {
  const { data } = await api.get<{ items: MarkupSceneSummary[] } | MarkupSceneSummary[]>(
    `/projects/${projectId}/markup-scenes`,
  );
  // Backend kann beide Formen liefern — wir normalisieren auf Array.
  return Array.isArray(data) ? data : data.items;
}

export async function getScene(id: number): Promise<MarkupSceneDetail> {
  const { data } = await api.get<MarkupSceneDetail>(`/markup-scenes/${id}`);
  return data;
}

export async function createScene(
  projectId: number,
  body: CreateMarkupSceneRequest,
): Promise<MarkupSceneDetail> {
  const { data } = await api.post<MarkupSceneDetail>(`/projects/${projectId}/markup-scenes`, body);
  return data;
}

export async function updateScene(
  id: number,
  body: UpdateMarkupSceneRequest,
): Promise<MarkupSceneDetail> {
  const { data } = await api.patch<MarkupSceneDetail>(`/markup-scenes/${id}`, body);
  return data;
}

export async function deleteScene(id: number): Promise<void> {
  await api.delete(`/markup-scenes/${id}`);
}

export async function uploadThumbnail(id: number, blob: Blob): Promise<void> {
  const form = new FormData();
  form.append('file', blob, `scene-${id}.png`);
  await api.post(`/markup-scenes/${id}/thumbnail`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

/** URL zum Thumbnail — wird direkt im <img src> verwendet. */
export function thumbnailUrl(id: number): string {
  return `/api/v1/markup-scenes/${id}/thumbnail`;
}
